import React from 'react';
import { isQAActive } from '../../../../../data/filters/questions/isQAActive';
import { useEvent } from '../../../../../data/hooks/eventHooks';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import StartNetworkingGroup from '../../StartNetworkingGroup';
import icon from './icon.png';
import StepPostQuest from './StepPostQuest';
import StepSubscribeCategory from './StepSubscribeCategory';
import StepViewQA from './StepViewQA';
import LoadQAQuestions from '../../../../loaders/LoadQAQuestions';

function QuestsGroup(props) {
    const { eventId } = props,
        i18n = useI18n(),
        event = useEvent(eventId);

    return (
        <LoadQAQuestions eventId={eventId}>
            <StartNetworkingGroup name={i18n['start.quests']} description={i18n['start.quests.intro']} visible={isQAActive(event)} icon={icon}>
                <StepViewQA eventId={eventId} />
                <StepPostQuest eventId={eventId} />
                <StepSubscribeCategory eventId={eventId} />
            </StartNetworkingGroup>
        </LoadQAQuestions>
    );
}

export default QuestsGroup;
